import React from 'react';
import HighlightCol from './HighlightCol';

function Highlights() {
    return (
        <div className="highlights">
            <div className="row_high">
                <HighlightCol
                    url={require("../img/Team.png")}
                    alt="Twitter Codechella 2020"
                    context="Worked with my team on Twitter API during Twitter's #Codechella 2020 hackathon"
                />
                <HighlightCol
                    url={require("../img/MLHBuild.jpg")}
                    alt="MLH Build 2019"
                    context="Won 2nd prize with my team at MLH Local Hack Day Build 2019"
                />

            </div>
        </div>

    );
}
export default Highlights;